<div class="container mt-4">
    <div class="w-100 d-flex justify-content-center mt-4">
        <table class="table table-striped">
            <tbody>
                <tr *ngFor="let item of shortListProducts">
                    <th max-width="40%">{{ item.bonusType }}</th>
                    <td>{{ item.product }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="mt-5" [formGroup]="formGroup" *ngIf="formGroup">
        <!-- SUSTAINABILITY -->
        <div class="form-group row my-3">
            <label for="sustainability" class="col-4 col-form-label">{{ "survey.new.savings-short-list.sustainability" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="sustainability" formControlName="sustainability">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(sustainability)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- PATRIMONIAL RATIO -->
        <div class="form-group row my-3">
            <label for="patrimonialRatio" class="col-4 col-form-label">{{ "survey.new.savings-short-list.patrimonial-ratio" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="patrimonialRatio" formControlName="patrimonialRatio">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.savings-short-list.patrimonial-ratio." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(patrimonialRatio)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- SOLIDITY -->
        <div class="form-group row my-3">
            <label for="solidity" class="col-4 col-form-label">{{ "survey.new.savings-short-list.solidity" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="solidity" formControlName="solidity">
                    <option *ngFor="let key of ['Y', 'N']" [value]="key">
                        {{ "survey.domain.optional." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(solidity)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- COMPANY -->
        <div class="form-group row my-3">
            <label for="companyCode" class="col-4 col-form-label">{{ "survey.new.savings-short-list.company" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="companyCode" formControlName="companyCode">
                    <option *ngFor="let key of ['A', 'B']" [value]="key">
                        {{ "survey.domain.savings-short-list.company." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(companyCode)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- SUBMIT -->
        <button *ngIf="isInsert()" class="btn btn-primary mt-5 next-step" [disabled]="completed" (click)="onSubmit()">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            {{ "survey.new.protection.next" | translate }}
        </button>
    </div>
</div>
